import { RoleEnum } from '@zaoblako/shared/modules/security/enums/role.enum';
import { RoleEnumI18n } from '@zaoblako/shared/modules/security/i18n/role.enum.i18n';
import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { SecurityDtoKeysEnum } from '@zaoblako/shared/modules/security/enums/security-dto-keys.enum';
import { commonEnumValidator } from '@zaoblako/shared/modules/serde/validators/common-enum.validator';
import { SecurityBackendValidatorsEnum } from '@zaoblako/shared/modules/security/enums/security-backend-validators.enum';
import { nonEmptyStringSchema } from '@zaoblako/shared/modules/serde/schemas/non-empty-string.schema';

/** Role create and update APIs request body - DTO signature */
export interface RoleFormInterface {
  /** Display name */
  name: string;
  /** Role type */
  type: RoleEnum;
}

/** Role create and update APIs request body - DTO schema */
export const RoleFormDto = SerdeDtoClass.create<RoleFormInterface>(SecurityDtoKeysEnum.ROLE_FORM_DTO, {
  name: {
    label: 'Название',
    serializer: nonEmptyStringSchema,
    checkers: [SecurityBackendValidatorsEnum.ROLE_NAME_UNIQUE],
  },
  type: {
    label: 'Тип',
    serializer: commonEnumValidator(RoleEnum, RoleEnumI18n),
  },
});
